import { Component, OnInit } from '@angular/core';
import { CasetodayService } from '../../../casetoday.service';
import { LawyerinfoService } from '../../../lawyerinfo.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import {formatDate} from '@angular/common';

@Component({
  selector: 'app-search-list-by-date-highcourt',
  templateUrl: './search-list-by-date-highcourt.component.html',
  styleUrls: ['./search-list-by-date-highcourt.component.css']
})
export class SearchListByDateHighcourtComponent implements OnInit {

  location:any = null;
 
  todaysdata:any = [];
  lawyerinfodata:any = [];
  previous_results:any = [];
  previous_results_datatime: any;
  previous_date: any;

  lawyerCode: any;
  searchDate: Date = new Date();

  input_lawyer_code: string;

  errorMessage: string;

  is_draft: number;

  isLoading: boolean = true;

  detailsdata:boolean = false;
  isLoadingImage: boolean = false;
  
  SuCMessage: boolean = true;

  errorMsg: boolean = false;
  errorMsg2: boolean = false;
  
  current_date: string;
  current_username: string;
  current_laywerCode: string;

  lawyergroupdata:any = [];

  is_admin: boolean = false;

  
  isBlockSearchList: boolean = false;

  constructor(
    public rest:CasetodayService, 
      public lawyerinfo_api:LawyerinfoService, 
      private route: ActivatedRoute, 
      private router: Router,
      public app:AppComponent
  ) { 

    if (!this.app.loggedIn()) {
      //this.location.replaceState('/');
      this.router.navigate(['../']);
    }  

  }

  ngOnInit() {
    
    window.scrollTo({
      top: 1400,
      left: 0, 
      behavior: 'smooth'
    });
    

    this.current_username = this.app.getUserName();
    this.current_laywerCode = this.app.getLawyerCode();
    this.is_admin = this.app.isAdmin(); 
 
    this.current_date = formatDate(new Date(), 'dd-MM-yyyy', 'en');

    if(!this.is_admin){
       this.getLawyerInfoSadmin();
    }

    this.getLawyerGroup();

    
    this.getSearchListBlockStatus(); 

  }
  
  getCasetoday() {

    
    this.getSearchListBlockStatus(); 

    this.is_draft = 0;
    this.todaysdata = [];
    this.lawyerinfodata = [];
    this.previous_results = [];
    this.previous_results_datatime = [];
    this.previous_date = [];

    if(this.is_admin){

      this.input_lawyer_code = this.lawyerCode;

      if(this.input_lawyer_code === undefined || this.input_lawyer_code == ""){
        this.errorMsg2 = true;
        this.isLoading = true;
        return;
      } else if (this.searchDate === undefined || this.searchDate == null){
        this.errorMsg2 = false;
        this.errorMsg = true;
        this.isLoading = true;
        return;
      }

      this.current_date = formatDate(this.searchDate, 'dd-MM-yyyy', 'en');
      this.errorMsg = false;
      this.errorMsg2 = false;

    } else {
      
      this.input_lawyer_code = this.current_laywerCode;

      if (this.searchDate === undefined || this.searchDate == null){
        this.errorMsg = true;
        this.isLoading = true;
        return;
      }

      this.current_date = formatDate(this.searchDate, 'dd-MM-yyyy', 'en');
      this.errorMsg = false;
    }    

    let postData = {
      lawyerCode: this.input_lawyer_code,
      searchDate: this.searchDate,
    }    

    this.getLawyerInfo();
    
    this.isLoadingImage = true
    this.detailsdata = false

    this.SuCMessage = false;

    this.rest
            .getCasetoday(postData)
            .subscribe(
                todaysdata => {
                    this.todaysdata = todaysdata
                    this.isLoading = false
                    this.errorMessage = ""
                    this.isLoadingImage = false
                    this.detailsdata = true
                    this.SuCMessage = false
                }, 
                error => {
                    this.errorMessage = <any>error
                    this.isLoading = false
                    this.isLoadingImage = false
                    this.SuCMessage = false
                }
            );

    this.rest
            .getPreviousResult(postData)
            .subscribe(
              previous_results => {
                    this.previous_results = previous_results
                }
            );

    this.rest
            .getPreviousResultDateTime(postData)
            .subscribe(
              previous_results_datatime => {
                    this.previous_results_datatime = previous_results_datatime
                }
            );

    this.rest
            .getPreviousDate(postData)
            .subscribe(
              previous_date => {
                    this.previous_date = previous_date
                }
            );           

    this.rest
            .getDraftStatus(postData)
            .subscribe(
              is_draft => {
                    this.is_draft = is_draft
                }
            );   
  }
  
  getLawyerInfo() {
    let postData = {
      lawyerCode: this.input_lawyer_code
    }
    
    this.lawyerinfo_api
            .getLawyerinfo(postData)
            .subscribe(
                lawyerinfodata => {
                    this.lawyerinfodata = lawyerinfodata
                    this.isLoading = false
                },
                error => {
                    this.errorMessage = <any>error
                    this.isLoading = false
                }
            );
  }

  getLawyerInfoSadmin() {
    let postData = {
      lawyerCode: this.input_lawyer_code
    }
    
    this.lawyerinfo_api
            .getLawyerInfoSadmin(postData)
            .subscribe(
                lawyerinfodata => {
                    this.lawyerinfodata = lawyerinfodata
                },
                error => {
                    this.errorMessage = <any>error
                }
            );
  }

  getLawyerGroup() {
    let postData = {
      lawyerCode: this.current_laywerCode
    }
    
    this.lawyerinfo_api
            .getLawyerGroup(postData)
            .subscribe(
                lawyergroupdata => {
                    this.lawyergroupdata = lawyergroupdata
                    this.isLoading = false
                },
                error => {
                    this.errorMessage = <any>error
                    this.isLoading = false
                }
            );
  }


  getSearchListBlockStatus() {
    let postData = {
      id: 1
    }
    
    this.lawyerinfo_api
            .getSearchListBlockStatus(postData)
            .subscribe(
              isBlockSearchList => {
                    this.isBlockSearchList = isBlockSearchList,
                    this.isLoading = false
                    //console.log("===="+isBlockSearchList[0].is_block_hd);
                },
                error => {
                    this.errorMessage = <any>error
                    this.isLoading = false
                }
            );
  }


}
